<template>
  <div v-if="imageBase64">
    <div v-if="cropPopupVisible">
      <vue-cropper
        :aspectRatio="aspectRatio"
        :src="imageBase64"
        alt="Image Crop"
        ref="cropper"
        class="cropper"
        :view-mode="2"
        style="width: 80%; margin: 0 auto 15px"
      ></vue-cropper>
    </div>
    <div class="flex mt-3 items-center">
      <vs-button
        @click="rotate(90)"
        icon="icon-rotate-cw"
        icon-pack="feather"
        style="width: 100px !important"
        color="primary"
        type="border"
      />
      <vs-button
        @click="cropImage"
        icon="check"
        class="w-full mx-5"
        color="primary"
        >تایید</vs-button
      >
      <vs-button
        @click="rotate(-90)"
        icon="icon-rotate-ccw"
        icon-pack="feather"
        style="width: 100px !important"
        color="primary"
        type="border"
      />
    </div>
  </div>
  <loader v-else></loader>
</template>

<script>
import VueCropper from "vue-cropperjs";

// Cropped images are always encoded as JPEG regardless of the source format: PNG
// is lossless and inflates a detailed photo several times over, pushing it past
// the server's upload limit. JPEG has no alpha channel, so transparent areas are
// filled white to avoid a black background, and the canvas is capped so large
// photos stay within the limit.
const OUTPUT_MIME = "image/jpeg";
const OUTPUT_QUALITY = 0.9;
const OUTPUT_FILL_COLOR = "#fff";
const OUTPUT_MAX_DIMENSION = 1000;

export default {
  name: "Cropper",
  components: { VueCropper },
  props: {
    imageBase64: {
      type: String,
      required: true,
    },
    cropPopupVisible: {
      type: Boolean,
      required: true,
    },
    aspectRatio: {
      type: Number,
      required: true,
      default: 0,
    },
    fileType: {
      type: String,
      required: true,
    },
  },
  methods: {
    cropImage() {
      const canvas = this.$refs.cropper.cropper.getCroppedCanvas({
        maxWidth: OUTPUT_MAX_DIMENSION,
        maxHeight: OUTPUT_MAX_DIMENSION,
        fillColor: OUTPUT_FILL_COLOR,
        imageSmoothingQuality: "high",
      });

      if (!canvas) {
        this.notifyCropError();
        return;
      }

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            this.notifyCropError();
            return;
          }
          this.$emit("cropImage", blob);
        },
        OUTPUT_MIME,
        OUTPUT_QUALITY
      );
    },
    notifyCropError() {
      this.$vs.notify({
        text: "خطا در برش تصویر. لطفا مجدد تلاش کنید.",
        color: "danger",
        position: "bottom-center",
      });
    },
    rotate(degree) {
      this.$refs.cropper.cropper.rotate(degree);
    },
  },
};
</script>
